import LangEnum from '../../../../lang/LangEnum';
import {
  PriceRangeFilter,
  PriceRangeFilterV2,
} from '../../../Crud/filters/sharedBetweenFilters/types';
import { formatNumberLabel } from '../../components/NumberRangeFilter/numberRangeFilter.utils';
import { FilterFactoryGetLabelParams, IFilterHelperFactory } from '../filter-factory.types';

class NumberRangeFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: PriceRangeFilter | PriceRangeFilterV2) {}

  getChipLabel({ formatMoney, translate, locale }: FilterFactoryGetLabelParams) {
    const { hasDiffInMaxPrice, hasDiffInMinPrice } = this.getDiffs();

    const langEnum = this.getLangEnum(hasDiffInMinPrice, hasDiffInMaxPrice);

    const formatNumberRangeFilterType = this.filter.numberRangeArgs.type;
    const minValue = this.filter.numberRangeArgs.minValue;
    const maxValue = this.filter.numberRangeArgs.maxValue;

    const [formattedMinPrice, formattedMaxPrice] = [minValue, maxValue].map((value) =>
      formatNumberLabel(formatNumberRangeFilterType, value, formatMoney, locale),
    );

    return `${this.filter.title}: ${translate(langEnum, {
      minPrice: formattedMinPrice,
      maxPrice: formattedMaxPrice,
    })}`;
  }

  getFriendlyLabel(params: FilterFactoryGetLabelParams): string {
    return this.getChipLabel(params);
  }

  hasValue() {
    const { hasDiffInMaxPrice, hasDiffInMinPrice } = this.getDiffs();
    const hasAnyValue = hasDiffInMaxPrice || hasDiffInMinPrice;

    return !!hasAnyValue;
  }

  private getDiffs() {
    const minValue = this.filter.numberRangeArgs.minValue;
    const maxValue = this.filter.numberRangeArgs.maxValue;
    const minAvailableValue = this.filter.numberRangeArgs.minAvailableValue ?? 0;

    const hasDiffInMinPrice = minValue !== minAvailableValue;
    const hasDiffInMaxPrice = maxValue !== this.filter.numberRangeArgs.maxAvailableValue;

    return {
      hasDiffInMinPrice,
      hasDiffInMaxPrice,
    };
  }

  private getLangEnum(hasDiffInMinPrice: boolean, hasDiffInMaxPrice: boolean) {
    const possibilities = {
      between: LangEnum.FILTER_NUMBER_RANGE_FILTERING_BETWEEN,
      from: LangEnum.FILTER_NUMBER_RANGE_FILTERING_FROM,
      until: LangEnum.FILTER_NUMBER_RANGE_FILTERING_UNTIL,
    };

    const isBetween = hasDiffInMinPrice && hasDiffInMaxPrice;
    if (isBetween) {
      return possibilities.between;
    }

    const isFrom = hasDiffInMinPrice;
    if (isFrom) {
      return possibilities.from;
    }

    return possibilities.until;
  }

  isLoading() {
    return false;
  }
}

export default NumberRangeFilterHelper;
